// extracted by mini-css-extract-plugin
export default {"notification-bar":"NotificationStylesForAsideAndSpan-rebranding-module__notification-bar___nMSKC"};